// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_iv-6";
export var emphasizeQuantity = "_iv-3";
export var flatBottomCorners = "_iv-5";
export var productImage = "_iv-0";
export var quantityContainer = "_iv-2";
export var tooltip = "_iv-1";
export var wrapAndEllipsesOverflow = "_iv-4";